import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  orderSummary: {
    flex: 1,
    height: 'fit-content',
    padding: '16px 24px',
  },
  selectedProductsDetailsList: {
    flexDirection: 'column',
    rowGap: '34px',
    padding: '24px 0 34px 0',
  },
  productBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '& p': { color: theme.evPalette.charcoal[900] },
  },
  subscriptionProductLines: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
  productBlockHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
  /** Product name — Figma: Noto Sans 600, 14px, line-height 24px, letter-spacing 0 */
  productTitle: {
    '&&': {
      fontFamily: theme.typography?.fontFamily ?? '"Noto Sans", sans-serif',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: 0,
      color: theme.evPalette.charcoal[900],
    },
  },
  unitBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    padding: '4px 12px',
    borderRadius: '9999px',
    backgroundColor: '#E8EFFB',
    color: '#2274F7',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
  },
  overagePriceRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
  },
  overagePriceText: {
    '&&': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
      color: theme.evPalette.charcoal[900],
    },
  },
  productDescription: {
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.evPalette.charcoal[700],
    width: '80%',
    maxWidth: '80%',
  },
  /** Subscription finalize: delivery / add-on rows under product (heading + value column, price vertically centered) */
  subscriptionExtras: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '4px',
    width: '100%',
  },
  subscriptionExtraLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
    minWidth: 0,
  },
  subscriptionExtraLineText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: '1 1 auto',
    minWidth: 0,
  },
  subscriptionExtraLineHeading: {
    fontFamily: theme.typography?.fontFamily ?? '"Noto Sans", sans-serif',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: 0,
    color: theme.evPalette.charcoal[800],
  },
  subscriptionExtraLineValue: {
    fontFamily: theme.typography?.fontFamily ?? '"Noto Sans", sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: 0,
    color: theme.evPalette.charcoal[900],
  },
  subscriptionExtraLinePrice: {
    fontFamily: theme.typography?.fontFamily ?? '"Noto Sans", sans-serif',
    flexShrink: 0,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '100%',
    color: theme.evPalette.charcoal[900],
  },
  orderSummaryRows: {
    '&>.line1 p': { color: theme.evPalette.charcoal[900] },
    '&>.line2>p': { color: theme.evPalette.charcoal[700] },
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0',
    rowGap: '24px',
    '&:empty': { paddingBottom: 0 },
  },
  estimatedTotal: {
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    padding: '20px 0px',
    '& *': {
      color: theme.evPalette.charcoal[900],
      fontWeight: 600,
    },
  },
  subscriptionTotals: {
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  subscriptionTotalRow: {
    width: '100%',
  },
  subscriptionTotalLabel: {
    '&&': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: theme.evPalette.charcoal[900],
    },
  },
  subscriptionGrandTotalLabel: {
    '&&': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
      color: theme.evPalette.charcoal[900],
    },
  },
  subscriptionGrandTotalValue: {
    '&&': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
      color: theme.evPalette.charcoal[900],
    },
  },
  terms: {
    '&>p': {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[900],
    },
  },
  buttonContainer: {
    rowGap: '16px',
    flexDirection: 'column',
    '&>button': {
      flex: 1,
    },
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      '&>button': {
        flex: 'unset',
      },
    },
  },
  button: {
    height: '44px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
  },
}));
